import React from "react";

export default function Strip({ children }) {
  return (
    <div className="mb-12 text-center">
      <h1 className="text-3xl md:text-4xl font-bold text-vinefin-900 relative inline-block">
        {children}
        <span className="absolute bottom-0 left-0 w-full h-3 bg-vinefin-200 opacity-40 -z-10 rounded-full transform translate-y-1"></span>
      </h1>
    </div>
  );
}
